import AgentsPublicNavigation from "./AgentsPublicNavigation";
import RewardsPublicNavigation from "./RewardsPublicNavigation";

var exporDefault;

if(process.env.REACT_APP_BRAND === 'marivalagents'){
 exporDefault = AgentsPublicNavigation;
}

if(process.env.REACT_APP_BRAND === 'marivalrewards'){
  exporDefault = RewardsPublicNavigation;
 }

export default exporDefault;
